import { useMemo } from 'react';

import LoyaltyEarnBadge from '@components/LoyaltyBadge/LoyaltyBadge';
import Price from '@components/ui/price';
import { useDevice } from '@contexts/device';
import { MAX_SETUR_POINTS_EARN } from '@constants/constants';
import { useAuthState } from '@contexts/auth/AuthContext';

import {
  Button,
  EarnBadgeContainer,
  EarnBadgeWrapper,
  LoyaltyEarnBadgeWrapper,
  VerificationButtonContainer,
} from './styles';
import { PackageVariationProps } from './types';

type Props = PackageVariationProps & {
  priceShown: boolean;
  needVerification: boolean;
  validated: boolean;
  handleShowVerificationModal: () => void;
};

// ==================================
// Desktop Verification Button Container
// ==================================
export const DesktopVerificationButtonContainer = ({
  seturLoyaltyInfo,
  hasLoyaltyVariation,
  tryTotalDiscountedSellingPrice,
  validated,
  priceShown,
  needVerification,
  handleShowVerificationModal,
}: Props) => {
  const { isDesktop } = useDevice();
  const { loginInfo } = useAuthState();
  const isLoggedIn = !!loginInfo?.token;

  const showMaxLoyaltyEarnPoints = useMemo(() => {
    return (
      !isLoggedIn && (seturLoyaltyInfo?.earn ?? 0) >= MAX_SETUR_POINTS_EARN
    );
  }, [isLoggedIn, seturLoyaltyInfo]);

  return (
    <VerificationButtonContainer
      alignItems='center'
      justifyContent='flex-end'
      verified={priceShown}
    >
      {needVerification && !validated ? (
        <>
          {isDesktop && !needVerification ? (
            <EarnBadgeWrapper>
              <EarnBadgeContainer>
                <LoyaltyEarnBadge
                  discount={seturLoyaltyInfo?.rate}
                  earn={seturLoyaltyInfo?.earn}
                  showMaxLoyaltyEarn={showMaxLoyaltyEarnPoints}
                />
              </EarnBadgeContainer>

              <Button outline onClick={handleShowVerificationModal}>
                Doğrula
              </Button>
            </EarnBadgeWrapper>
          ) : (
            <Button outline onClick={handleShowVerificationModal}>
              Doğrula
            </Button>
          )}
        </>
      ) : hasLoyaltyVariation && isDesktop ? (
        <LoyaltyEarnBadgeWrapper>
          <LoyaltyEarnBadge
            discount={seturLoyaltyInfo?.rate}
            earn={seturLoyaltyInfo?.earn}
            showMaxLoyaltyEarn={showMaxLoyaltyEarnPoints}
          />
          <Price price={tryTotalDiscountedSellingPrice} />
        </LoyaltyEarnBadgeWrapper>
      ) : (
        <Price price={tryTotalDiscountedSellingPrice} />
      )}
    </VerificationButtonContainer>
  );
};

// ==================================
// Mobile Verification Button Container
// ==================================
export const MobileVerificationButtonContainer = ({
  tryTotalDiscountedSellingPrice,
  validated,
  priceShown,
  needVerification,
}: Props) => {
  return (
    <>
      {needVerification && !validated ? null : (
        <VerificationButtonContainer
          alignItems='center'
          justifyContent='flex-end'
          verified={priceShown}
        >
          <Price price={tryTotalDiscountedSellingPrice} />
        </VerificationButtonContainer>
      )}
    </>
  );
};
